import { supabase } from '../supabaseClient';

// 列出馈线选项（基于后端设备库）
export async function listFeedersAsync() {
  try {
    const { data, error } = await supabase
      .from('feeders_view')
      .select('id, name, label')
      .order('name', { ascending: true });
    if (error) return [];
    return (data || []).map(f => ({ value: f.id, label: f.label || f.name || f.id }));
  } catch (_) {
    return [];
  }
}

// 获取馈线详情（展平后端视图为前端结构）
export async function fetchFeederByIdAsync(id) {
  if (!id) return null;
  try {
    const { data, error } = await supabase
      .from('feeders_view')
      .select('*')
      .eq('id', id)
      .single();
    if (error || !data) return null;
    const f = data;
    return {
      id: f.id,
      name: f.name,
      label: f.label || f.name || f.id,
      bus: { voltage_kV: f.bus_voltage_kV },
      ratedCurrent: f.rated_current || f.ratedCurrent,
      ctRatio: f.ct_ratio || f.ctRatio,
      ptRatio: f.pt_ratio || f.ptRatio, // 增加 PT 变比回填
      source: { S_sc_MVA: f.source_S_sc_MVA, X_R: f.source_X_R },
      transformer: { 
        S_tr_MVA: f.S_tr_MVA, 
        uk_percent: f.uk_percent, 
        vector_group: f.vector_group, 
        secondary_neutral_ground: f.secondary_neutral_ground 
      },
      line: { 
        R_per_km_ohm: f.R_per_km_ohm, 
        X_per_km_ohm: f.X_per_km_ohm, 
        length_km: f.length_km, 
        z0_factor: f.z0_factor 
      },
      ground: { R_ohm: f.ground_R_ohm, X_ohm: f.ground_X_ohm },
      // 设备引用信息（用于保存时写入版本戳与来源）
      ct_id: f.ct_id,
      pt_id: f.pt_id,
      relay_id: f.relay_id,
      ct_name: f.ct_name,
      pt_name: f.pt_name,
      relay_name: f.relay_name || f.relay_model
    };
  } catch (_) {
    return null;
  }
}